import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import SignedOut from './components/SignedOut';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/callback" element={<Dashboard />} />
          <Route path="/signed-out" element={<SignedOut />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
